import React from 'react';
import { SxProps, Typography } from '@mui/material';

export interface Props {
  children: React.ReactNode;
  marginRight?: string;
  sx?: SxProps;
  color?: string;
}

const customSx = {
  color: '#e9e9e9',
  fontSize: 12,
  fontFamily: 'Monospace',
  fontWeight: 'fontWeightBold',
  whiteSpace: 'nowrap',
};

export const CustomTypography: React.FC<Props> = ({ children, marginRight, sx, color }) => {
  const dynamicSx = {
    ...customSx,
    ...(color ? { color } : {}),
    ...(marginRight ? { marginRight } : {}),
    ...sx,
  };

  return (
    <Typography component="span" sx={dynamicSx}>
      {children}
    </Typography>
  );
};
